import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Material from '@primeuix/themes/material';
import { definePreset } from '@primeuix/themes';
import { Auth } from './core/auth/auth';
import { authInterceptor } from './core/http/auth-interceptor';
import { errorInterceptor } from './core/http/error-interceptor';
import { browserFingerprintInterceptor } from './core/http/browser-fingerprint.interceptor';
import { provideHttpClient, withInterceptors, withFetch } from '@angular/common/http';
import { DialogService } from 'primeng/dynamicdialog';

const UltimaPreset = definePreset(Material, {
  semantic: {
    primary: {
      50: '{indigo.50}',
      100: '{indigo.100}',
      200: '{indigo.200}',
      300: '{indigo.300}',
      400: '{indigo.400}',
      500: '{indigo.500}',
      600: '{indigo.600}',
      700: '{indigo.700}',
      800: '{indigo.800}',
      900: '{indigo.900}',
      950: '{indigo.950}',
    },
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(),
    provideAnimationsAsync(),
    providePrimeNG({
      ripple: true,
      inputStyle: 'filled',
      theme: {
        preset: UltimaPreset,
        options: { darkModeSelector: '.app-dark' },
      },
    }),
    DialogService,
    provideHttpClient(
       withFetch(),
      withInterceptors([authInterceptor, errorInterceptor, browserFingerprintInterceptor])),
    provideAppInitializer(() => {
      const auth = inject(Auth);
      if (!auth.isLoggedIn()) return;
      return firstValueFrom(auth.loadUser()).catch(() => void 0);
    }),
  ]
};